/* eslint semi:0 */
import { connect, } from 'react-redux'
import React, { Component, } from 'react'
import reduxMount from '../../jsCore/utils/reduxMounter'
import { MOUNT_POINTS, } from '../../jsCore/config/preRenderedSelectorsConfig'
import { scheduleReducer, } from './scheduleReducer'
import LeagueSelection from './components/leagueSelection'
import {
  changeLeague, fetchData,
} from 'components/schedule/scheduleActions'
import {
  transformMatchResponseToFixturesSchedule,
} from 'components/schedule/scheduleScoresTransformUtil'


const STATE_KEY = 'scheduleComponent'
const COMPONENT_NAME = 'FixturesLeagueSelectionContainer'
const LEAGUE_SELECTION_SCORES_MODIFIER = 'scores'


function mapStateToProps(state){
  const { leaguesForFixtures, leagueName, } = state[STATE_KEY]
  return {
    leaguesForFixtures,
    leagueName,
  }
}

export class FixturesLeagueSelection extends Component {

  componentWillMount(){
    const { IS_INITIALIZED, dispatch, } = this.props
    if (!IS_INITIALIZED) {
      dispatch(fetchData(transformMatchResponseToFixturesSchedule))
    }
  }

  onLeagueChanged(e){
    const { value: selectedLeague, } = e.target
    this.props.dispatch(changeLeague(selectedLeague))
  }

  render(){
    const { leagueName, leaguesForFixtures, } = this.props
    const leagueNamesForSelection = leaguesForFixtures.map(l => l.name)
    const leagueSelectionProps = {
      currentLeague: leagueName,
      leagues: leagueNamesForSelection,
      modifier: LEAGUE_SELECTION_SCORES_MODIFIER,
      onChangeLeagueHandler: this.onLeagueChanged.bind(this),
    }
    return <LeagueSelection { ...leagueSelectionProps } />
  }

}

const FixturesLeagueSelectionContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: connect(mapStateToProps)(FixturesLeagueSelection),
  reducer: scheduleReducer,
}

export default function mountFixturesLeagueSelection(){
  return reduxMount({
    [MOUNT_POINTS.LEAGUE_SELECTION_COMPONENT_IN_FIXTURES_PAGE]:
      FixturesLeagueSelectionContainer,
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/leagueSelectionScoresContainer.js